module.exports = __webpack_public_path__ + "static/media/pinMarineBlue.2207987e.svg";